const debtToAssetsData = [
  {
    month: ["2021", "Aug"],
    totalAssets: 4593872.24,
    grossDebtToLiquidAssets: 1.72,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.29,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 3441645.23,
    cash: 836829.02,
    totalDebt: 5934705.0,
  },
  {
    month: ["2021", "Sep"],
    totalAssets: 5019494.7,
    grossDebtToLiquidAssets: 1.68,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.29,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 3868935.52,
    cash: 383270.55,
    totalDebt: 6490470.32,
  },
  {
    month: ["2021", "Oct"],
    totalAssets: 5984192.71,
    grossDebtToLiquidAssets: 1.32,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.06,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 4798523.89,
    cash: 801144.55,
    totalDebt: 6357936.11,
  },
  {
    month: ["2021", "Nov"],
    totalAssets: 6764845.33,
    grossDebtToLiquidAssets: 1.11,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 0.91,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 5548845.97,
    cash: 1453189.69,
    totalDebt: 6156903.37,
  },
  {
    month: ["2021", "Dec"],
    totalAssets: 6269656.43,
    grossDebtToLiquidAssets: 1.18,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 0.95,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 5035201.15,
    cash: 2093477.41,
    totalDebt: 5960235.29,
  },
  {
    month: ["2022", "Jan"],
    totalAssets: 5176376.59,
    grossDebtToLiquidAssets: 1.51,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.15,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 3932703.98,
    cash: 965303.76,
    totalDebt: 5934705.0,
  },
  {
    month: ["2022", "Feb"],
    totalAssets: 5733235.75,
    grossDebtToLiquidAssets: 1.51,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.18,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 4479273.21,
    cash: 1371971.53,
    totalDebt: 6760812.11,
  },
  {
    month: ["2022", "Mar"],
    totalAssets: 4958143.1,
    grossDebtToLiquidAssets: 1.78,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.33,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 3704489.59,
    cash: 349492.07,
    totalDebt: 6611734.23,
  },
  {
    month: ["2022", "Apr"],
    totalAssets: 5211921.08,
    grossDebtToLiquidAssets: 1.9,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.44,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 3957060.37,
    cash: 421236.79,
    totalDebt: 7521041.84,
  },
  {
    month: ["2022", "May"],
    totalAssets: 4871050.91,
    grossDebtToLiquidAssets: 2.04,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.52,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 3610983.37,
    cash: 119722.82,
    totalDebt: 7380070.88,
  },
  {
    month: ["2022", "Jun"],
    totalAssets: 5476439.08,
    grossDebtToLiquidAssets: 1.95,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.5,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 4212280.18,
    cash: 412926.4,
    totalDebt: 8193762.49,
  },
  {
    month: ["2022", "Jul"],
    totalAssets: 5731036.17,
    grossDebtToLiquidAssets: 1.99,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.55,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 4465389.57,
    cash: 496691.42,
    totalDebt: 8901556.23,
  },
  {
    month: ["2022", "Aug"],
    totalAssets: 5970116.05,
    grossDebtToLiquidAssets: 1.86,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.45,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 4654583.25,
    cash: 299495.54,
    totalDebt: 8642556.11,
  },
  {
    month: ["2022", "Sep"],
    totalAssets: 6244422.68,
    grossDebtToLiquidAssets: 1.84,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.45,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 4903765.67,
    cash: 144536.11,
    totalDebt: 9036263.37,
  },
  {
    month: ["2022", "Oct"],
    totalAssets: 6669938.68,
    grossDebtToLiquidAssets: 1.68,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.34,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 5317295.03,
    cash: 511916.49,
    totalDebt: 8938266.3,
  },
  {
    month: ["2022", "Nov"],
    totalAssets: 7232194.8,
    grossDebtToLiquidAssets: 1.44,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.16,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 5845771.54,
    cash: 1500152.8,
    totalDebt: 8401465.87,
  },
  {
    month: ["2022", "Dec"],
    totalAssets: 5657649.77,
    grossDebtToLiquidAssets: 1.74,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.31,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 4270844.01,
    cash: 776161.2,
    totalDebt: 7419475.0,
  },
  {
    month: ["2023", "Jan"],
    totalAssets: 5964614.99,
    grossDebtToLiquidAssets: 1.83,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.4,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 4560549.23,
    cash: 1496772.12,
    totalDebt: 8350488.2,
  },
  {
    month: ["2023", "Feb"],
    totalAssets: 4503351.53,
    grossDebtToLiquidAssets: 2.65,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.82,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 3085608.38,
    cash: 35759.9,
    totalDebt: 8186478.09,
  },
  {
    month: ["2023", "Mar"],
    totalAssets: 4722787.64,
    grossDebtToLiquidAssets: 2.59,
    debtToTotalAssetsFromRemittanceReport: null,
    grossDebtToAssets: 1.81,
    debtToLiquidAssetsFromRemittanceReport: null,
    balanceAvgInPeriod: null,
    debtBalanceEop: null,
    liquidAssets: 3291250.89,
    cash: 330112.56,
    totalDebt: 8532644.87,
  },
  {
    month: ["2023", "Apr"],
    totalAssets: 5360519.6,
    grossDebtToLiquidAssets: 2.33,
    debtToTotalAssetsFromRemittanceReport: 0.07,
    grossDebtToAssets: 1.71,
    debtToLiquidAssetsFromRemittanceReport: -0.12,
    balanceAvgInPeriod: 375000.0,
    debtBalanceEop: 750000.0,
    liquidAssets: 3916742.85,
    cash: 834658.4,
    totalDebt: 9144386.24,
  },
  {
    month: ["2023", "May"],
    totalAssets: 5657914.67,
    grossDebtToLiquidAssets: 2.29,
    debtToTotalAssetsFromRemittanceReport: 0.2,
    grossDebtToAssets: 1.71,
    debtToLiquidAssetsFromRemittanceReport: -0.02,
    balanceAvgInPeriod: 1125000.0,
    debtBalanceEop: 1500000.0,
    liquidAssets: 4240122.86,
    cash: 1189551.45,
    totalDebt: 9692323.5,
  },
  {
    month: ["2023", "Jun"],
    totalAssets: 5541079.01,
    grossDebtToLiquidAssets: 2.4,
    debtToTotalAssetsFromRemittanceReport: 0.27,
    grossDebtToAssets: 1.79,
    debtToLiquidAssetsFromRemittanceReport: 0.16,
    balanceAvgInPeriod: 1500000.0,
    debtBalanceEop: 1500000.0,
    liquidAssets: 4149607.61,
    cash: 853773.23,
    totalDebt: 9943909.91,
  },
  {
    month: ["2023", "Jul"],
    totalAssets: 5385721.35,
    grossDebtToLiquidAssets: 2.45,
    debtToTotalAssetsFromRemittanceReport: 0.28,
    grossDebtToAssets: 1.83,
    debtToLiquidAssetsFromRemittanceReport: 0.23,
    balanceAvgInPeriod: 1500000.0,
    debtBalanceEop: 1500000.0,
    liquidAssets: 4019486.96,
    cash: 565946.54,
    totalDebt: 9865314.61,
  },
  {
    month: ["2023", "Aug"],
    totalAssets: 6113524.21,
    grossDebtToLiquidAssets: 2.03,
    debtToTotalAssetsFromRemittanceReport: 0.24,
    grossDebtToAssets: 1.58,
    debtToLiquidAssetsFromRemittanceReport: 0.09,
    balanceAvgInPeriod: 1482839.79,
    debtBalanceEop: 1465679.57,
    liquidAssets: 4755751.32,
    cash: 1051243.87,
    totalDebt: 9640737.11,
  },
  {
    month: ["2023", "Sep"],
    totalAssets: 5840188.49,
    grossDebtToLiquidAssets: 2.09,
    debtToTotalAssetsFromRemittanceReport: 0.25,
    grossDebtToAssets: 1.62,
    debtToLiquidAssetsFromRemittanceReport: 0.27,
    balanceAvgInPeriod: 1430976.56,
    debtBalanceEop: 1396273.54,
    liquidAssets: 4509263.18,
    cash: 229324.62,
    totalDebt: 9443092.5,
  },
  {
    month: ["2023", "Oct"],
    totalAssets: 7186925.49,
    grossDebtToLiquidAssets: 1.66,
    debtToTotalAssetsFromRemittanceReport: 0.19,
    grossDebtToAssets: 1.33,
    debtToLiquidAssetsFromRemittanceReport: 0.03,
    balanceAvgInPeriod: 1360796.82,
    debtBalanceEop: 1325320.1,
    liquidAssets: 5742972.67,
    cash: 1177695.44,
    totalDebt: 9539217.66,
  },
  {
    month: ["2023", "Nov"],
    totalAssets: 8288649.98,
    grossDebtToLiquidAssets: 1.38,
    debtToTotalAssetsFromRemittanceReport: 0.16,
    grossDebtToAssets: 1.1,
    debtToLiquidAssetsFromRemittanceReport: -0.22,
    balanceAvgInPeriod: 1289052.43,
    debtBalanceEop: 1252784.75,
    liquidAssets: 6648302.65,
    cash: 2753910.17,
    totalDebt: 9141559.4,
  },
  {
    month: ["2023", "Dec"],
    totalAssets: 7346455.69,
    grossDebtToLiquidAssets: 1.6,
    debtToTotalAssetsFromRemittanceReport: 0.17,
    grossDebtToAssets: 1.28,
    debtToLiquidAssetsFromRemittanceReport: -0.24,
    balanceAvgInPeriod: 1215708.49,
    debtBalanceEop: 1178632.23,
    liquidAssets: 5871865.99,
    cash: 2623131.82,
    totalDebt: 9410963.79,
  },
  {
    month: ["2024", "Jan"],
    totalAssets: 6973382.95,
    grossDebtToLiquidAssets: 1.71,
    debtToTotalAssetsFromRemittanceReport: 0.16,
    grossDebtToAssets: 1.35,
    debtToLiquidAssetsFromRemittanceReport: -0.18,
    balanceAvgInPeriod: 1140729.35,
    debtBalanceEop: 1102826.48,
    liquidAssets: 5506855.3,
    cash: 2138036.21,
    totalDebt: 9410232.79,
  },
  {
    month: ["2024", "Feb"],
    totalAssets: 6520360.97,
    grossDebtToLiquidAssets: 1.82,
    debtToTotalAssetsFromRemittanceReport: 0.16,
    grossDebtToAssets: 1.41,
    debtToLiquidAssetsFromRemittanceReport: -0.1,
    balanceAvgInPeriod: 1064078.56,
    debtBalanceEop: 1025330.64,
    liquidAssets: 5063132.98,
    cash: 1564853.85,
    totalDebt: 9205335.13,
  },
  {
    month: ["2024", "Mar"],
    totalAssets: 6301637.87,
    grossDebtToLiquidAssets: 1.87,
    debtToTotalAssetsFromRemittanceReport: 0.16,
    grossDebtToAssets: 1.44,
    debtToLiquidAssetsFromRemittanceReport: -0.05,
    balanceAvgInPeriod: 985718.83,
    debtBalanceEop: 946107.03,
    liquidAssets: 4855452.5,
    cash: 1221752.51,
    totalDebt: 9102520.8,
  },
  {
    month: ["2024", "Apr"],
    totalAssets: 5607513.1,
    grossDebtToLiquidAssets: 2.16,
    debtToTotalAssetsFromRemittanceReport: 0.16,
    grossDebtToAssets: 1.6,
    debtToLiquidAssetsFromRemittanceReport: 0.12,
    balanceAvgInPeriod: 905612.08,
    debtBalanceEop: 865117.13,
    liquidAssets: 4172322.51,
    cash: 419327.05,
    totalDebt: 8999706.47,
  },
  {
    month: ["2024", "May"],
    totalAssets: 6953444.48,
    grossDebtToLiquidAssets: 1.88,
    debtToTotalAssetsFromRemittanceReport: 0.11,
    grossDebtToAssets: 1.5,
    debtToLiquidAssetsFromRemittanceReport: -0.18,
    balanceAvgInPeriod: 775198.94,
    debtBalanceEop: 685280.75,
    liquidAssets: 5525829.13,
    cash: 1758261.13,
    totalDebt: 10414365.17,
  },
  {
    month: ["2024", "Jun"],
    totalAssets: 6670771.66,
    grossDebtToLiquidAssets: 1.94,
    debtToTotalAssetsFromRemittanceReport: 0.1,
    grossDebtToAssets: 1.53,
    debtToLiquidAssetsFromRemittanceReport: -0.13,
    balanceAvgInPeriod: 647279.1,
    debtBalanceEop: 609277.46,
    liquidAssets: 5284191.3,
    cash: 1325360.54,
    totalDebt: 10238265.5,
  },
  {
    month: ["2024", "Jul"],
    totalAssets: 6010165.65,
    grossDebtToLiquidAssets: 2.16,
    debtToTotalAssetsFromRemittanceReport: 0.09,
    grossDebtToAssets: 1.67,
    debtToLiquidAssetsFromRemittanceReport: 0.02,
    balanceAvgInPeriod: 570809.25,
    debtBalanceEop: 532341.04,
    liquidAssets: 4645681.19,
    cash: 456598.43,
    totalDebt: 10038781.02,
  },
  {
    month: ["2024", "Aug"],
    totalAssets: 6251917.74,
    grossDebtToLiquidAssets: 1.99,
    debtToTotalAssetsFromRemittanceReport: 0.08,
    grossDebtToAssets: 1.56,
    debtToLiquidAssetsFromRemittanceReport: -0.0,
    balanceAvgInPeriod: 493395.85,
    debtBalanceEop: 454450.67,
    liquidAssets: 4908545.89,
    cash: 515308.36,
    totalDebt: 9770639.62,
  },
  {
    month: ["2024", "Sep"],
    totalAssets: 6589615.64,
    grossDebtToLiquidAssets: 1.83,
    debtToTotalAssetsFromRemittanceReport: 0.06,
    grossDebtToAssets: 1.44,
    debtToLiquidAssetsFromRemittanceReport: -0.01,
    balanceAvgInPeriod: 415017.88,
    debtBalanceEop: 375585.09,
    liquidAssets: 5201638.28,
    cash: 474504.22,
    totalDebt: 9504984.04,
  },
  {
    month: ["2024", "Oct"],
    totalAssets: 6945624.8,
    grossDebtToLiquidAssets: 1.64,
    debtToTotalAssetsFromRemittanceReport: 0.05,
    grossDebtToAssets: 1.31,
    debtToLiquidAssetsFromRemittanceReport: -0.12,
    balanceAvgInPeriod: 335653.82,
    debtBalanceEop: 295722.56,
    liquidAssets: 5571499.41,
    cash: 980222.92,
    totalDebt: 9112023.28,
  },
  {
    month: ["2024", "Nov"],
    totalAssets: 7523522.73,
    grossDebtToLiquidAssets: 1.53,
    debtToTotalAssetsFromRemittanceReport: 0.03,
    grossDebtToAssets: 1.24,
    debtToLiquidAssetsFromRemittanceReport: -0.24,
    balanceAvgInPeriod: 255281.7,
    debtBalanceEop: 214840.85,
    liquidAssets: 6117144.64,
    cash: 1696292.61,
    totalDebt: 9344280.79,
  },
  {
    month: ["2024", "Dec"],
    totalAssets: 7666761.97,
    grossDebtToLiquidAssets: 1.52,
    debtToTotalAssetsFromRemittanceReport: 0.02,
    grossDebtToAssets: 1.21,
    debtToLiquidAssetsFromRemittanceReport: -0.39,
    balanceAvgInPeriod: 173879.04,
    debtBalanceEop: 132917.24,
    liquidAssets: 6119622.88,
    cash: 2574967.8,
    totalDebt: 9294593.28,
  },
  {
    month: ["2025", "Jan"],
    totalAssets: 6813294.62,
    grossDebtToLiquidAssets: 1.75,
    debtToTotalAssetsFromRemittanceReport: 0.01,
    grossDebtToAssets: 1.35,
    debtToLiquidAssetsFromRemittanceReport: -0.28,
    balanceAvgInPeriod: 91422.87,
    debtBalanceEop: 49928.5,
    liquidAssets: 5250426.58,
    cash: 1584024.86,
    totalDebt: 9207403.95,
  },
  {
    month: ["2025", "Feb"],
    totalAssets: 6941891.69,
    grossDebtToLiquidAssets: 1.69,
    debtToTotalAssetsFromRemittanceReport: 0.0,
    grossDebtToAssets: 1.31,
    debtToLiquidAssetsFromRemittanceReport: -0.3,
    balanceAvgInPeriod: 24964.24,
    debtBalanceEop: -0.01,
    liquidAssets: 5368252.96,
    cash: 1647578.58,
    totalDebt: 9083544.83,
  },
  {
    month: ["2025", "Mar"],
    totalAssets: 7909797.03,
    grossDebtToLiquidAssets: 1.56,
    debtToTotalAssetsFromRemittanceReport: 0.05,
    grossDebtToAssets: 1.25,
    debtToLiquidAssetsFromRemittanceReport: -0.32,
    balanceAvgInPeriod: 849999.99,
    debtBalanceEop: 849999.99,
    liquidAssets: 6341865.64,
    cash: 2455371.49,
    totalDebt: 9922188.83,
  },
  {
    month: ["2025", "Apr"],
    totalAssets: 7236867.53,
    grossDebtToLiquidAssets: 1.75,
    debtToTotalAssetsFromRemittanceReport: 0.12,
    grossDebtToAssets: 1.37,
    debtToLiquidAssetsFromRemittanceReport: -0.15,
    balanceAvgInPeriod: 849999.99,
    debtBalanceEop: 849999.99,
    liquidAssets: 5665791.26,
    cash: 1704202.32,
    totalDebt: 9910832.83,
  },
  {
    month: ["2025", "May"],
    totalAssets: 7252907.99,
    grossDebtToLiquidAssets: 1.73,
    debtToTotalAssetsFromRemittanceReport: 0.12,
    grossDebtToAssets: 1.36,
    debtToLiquidAssetsFromRemittanceReport: -0.16,
    balanceAvgInPeriod: 849999.99,
    debtBalanceEop: 849999.99,
    liquidAssets: 5697728.36,
    cash: 1753981.91,
    totalDebt: 9830157.41,
  },
  {
    month: ["2025", "Jun"],
    totalAssets: 7465486.35,
    grossDebtToLiquidAssets: 1.67,
    debtToTotalAssetsFromRemittanceReport: 0.17,
    grossDebtToAssets: 1.32,
    debtToLiquidAssetsFromRemittanceReport: -0.07,
    balanceAvgInPeriod: 1680551.74,
    debtBalanceEop: 1661103.5,
    liquidAssets: 5878520.82,
    cash: 1661007.56,
    totalDebt: 9830157.41,
  },
  {
    month: ["2025", "Jul"],
    totalAssets: 7492212.09,
    grossDebtToLiquidAssets: 1.67,
    debtToTotalAssetsFromRemittanceReport: 0.22,
    grossDebtToAssets: 1.31,
    debtToLiquidAssetsFromRemittanceReport: -0.01,
    balanceAvgInPeriod: 1641221.66,
    debtBalanceEop: 1621339.82,
    liquidAssets: 5902546.56,
    cash: 1684309.07,
    totalDebt: 9830157.41,
  },
];

export default debtToAssetsData;
